<template>
  <button
    type="button"
    class="navbar-toggler"
    :class="[{ toggled: toggled }, { collapsed: !toggled }]"
    data-toggle="collapse"
    data-target="#navbar"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-bar top-bar" :class="panziToggler?'isPanzi':''"></span>
    <span class="navbar-toggler-bar middle-bar" :class="panziToggler?'isPanzi':''"></span>
    <span class="navbar-toggler-bar bottom-bar" :class="panziToggler?'isPanzi':''"></span>
  </button>
</template>
<script>
export default {
  name: 'navbar-toggle-button',
  props: {
    toggled: Boolean,
    panziToggler:Boolean
  }
};
</script>
<style scoped>
.isPanzi{
background-color:#f8dd7d !important;
}
</style>
